import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { addressSchema } from '../../schemas';
import { Col, Row } from 'react-bootstrap';
import { postAddAddress, postPincode } from '../../apiservices/ApiServices';
import Loader from '../Loader/Loader';


const AddAddress = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [isDefault, setIsDefault] = useState(0);
    const [citys, setCitys] = useState([]);

    useEffect(() => {
        if (props?.isDefault) {
            setIsDefault(1);
        }
        else {
            setIsDefault(0);
        }
    }, [props?.isDefault])

    const initialValues = {
        firstName: props.editAddress?.first_name || '',
        lastName: props.editAddress?.last_name || '',
        addressLine1: props.editAddress?.address_line1 || '',
        addressLine2: props.editAddress?.address_line2 || '',
        landmark: props.editAddress?.landmark || '',
        state: props.editAddress?.state.name || '',
        city: props.editAddress?.city || '',
        postalCode: props.editAddress?.postal_code || '',
        mobile: props.editAddress?.mobile_no || '',
    }

    const postPincodes = async (postdata) => {
        try {
            const res = await postPincode(postdata);
            setCitys(res.data.data.city);
            setFieldValue('state', res.data.data.state[0].name);
            setFieldValue('city', res.data.data.city[0].pincode_id);
            setLoading(false);
        } catch (error) {
            console.log(error.response.data.message);
            setLoading(false);
        }
    };

    const handleAddAddress = async (values) => {
        setLoading(true);
        let postdata =
        {

            "id": props.editAddress?.id || '',
            "first_name": values.firstName,
            "last_name": values.lastName,
            "address_line1": values.addressLine1,
            "address_line2": values.addressLine2,
            "landmark": values.landmark,
            "state_id": values.state,
            "city": values.city,
            "postal_code": values.postalCode,
            "mobile_no": values.mobile,
            "is_default": props.editAddress?.is_default || isDefault,
        }
        try {
            const res = await postAddAddress(postdata);
            //props.toast.success(res.data.message);
            setLoading(false);
            props.getAddressLists();
            props.hendelCancel();
        } catch (error) {
            setLoading(false);
            props.toast.error(error.response.data.message);
        }
    };

    const handlePostalCodeChange = async (value) => {
        setLoading(true);
        const postdata = {
            "pincode": value,
        }
        setFieldValue('city', '');
        setCitys('');
        postPincodes(postdata)
    };

    const handlePostalCodeChangeUp = async (value, cityName) => {
        setLoading(true);
        const postdata = {
            "pincode": value,
        }
        setFieldValue('city', '');
        setCitys('');

        try {
            const res = await postPincode(postdata);
            setCitys(res.data.data.city);

            if (cityName) {
                const city = res.data.data.city.find((item) => item.city_name === cityName);
                setFieldValue('city', city.pincode_id);
            }
            else {
                setFieldValue('city', res.data.data.city[0].pincode_id);
            }
            setLoading(false);
        } catch (error) {
            console.log(error.response.data.message);
            setLoading(false);
        }
    };

    useEffect(() => {
    }, [citys])

    useEffect(() => {
        handlePostalCodeChangeUp(props.editAddress?.postal_code, props.editAddress?.city)
    }, [props.editAddress?.postal_code, props.editAddress?.city])

    const { values, errors, touched, handleBlur, setFieldValue, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: addressSchema,
        onSubmit: (values) => {
            handleAddAddress(values);
        }
    })

    return (
        <div className='forms'>
            <form id='addaddress' onSubmit={handleSubmit} autoComplete="off">
                <Row>
                    <Col md={4}>
                        <div className="field">
                            <label for="name">First Name <span className="req">*</span></label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                placeholder="Enter Your First Name"
                                autoComplete='off'
                                value={values.firstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.firstName && touched.firstName ? (
                                <p className='errormsg'>{errors.firstName}</p>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="field">
                            <label for="name">Last Name <span className="req">*</span></label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                placeholder="Enter Your Last Name"
                                autoComplete='off'
                                value={values.lastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.lastName && touched.lastName ? (
                                <p className='errormsg'>{errors.lastName}</p>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="field">
                            <label for="name">Mobile No. <span className="req">*</span></label>
                            <input
                                type="tel"
                                id="mobile"
                                name="mobile"
                                placeholder="Enter Your Mobile No."
                                autoComplete='off'
                                value={values.mobile}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.mobile && touched.mobile ? (
                                <p className='errormsg'>{errors.mobile}</p>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className="field">
                            <label for="name">Address Line 1 <span className="req">*</span></label>
                            <input type="text"
                                id="addressLine1"
                                name="addressLine1"
                                placeholder="Enter Your Address Line 1"
                                autoComplete='off'
                                value={values.addressLine1}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.addressLine1 && touched.addressLine1 ? (
                                <p className='errormsg'>{errors.addressLine1}</p>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className="field">
                            <label for="name">Address Line 2</label>
                            <input type="text"
                                id="addressLine2"
                                name="addressLine2"
                                placeholder="Enter Your Address Line 2"
                                autoComplete='off'
                                value={values.addressLine2}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className="field">
                            <label for="name">Landmark/Area</label>
                            <input
                                type="text"
                                id="landmark"
                                name="landmark"
                                placeholder="Enter Your Landmark/Area"
                                autoComplete='off'
                                value={values.landmark}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="field">
                            <label for="name">Postal Code <span className="req">*</span></label>
                            <input
                                type="text"
                                id="postalCode"
                                name="postalCode"
                                autoComplete='off'
                                placeholder="Enter Your Postal Code"
                                value={values.postalCode}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,6}$/.test(value)) { // Allow only numbers and max 6 digits
                                        setFieldValue("postalCode", value);
                                        if (value.length === 6) {
                                            handlePostalCodeChange(value);
                                        }
                                    }
                                }}
                                onBlur={handleBlur}
                            />
                            {errors.postalCode && touched.postalCode ? (
                                <p className='errormsg'>{errors.postalCode}</p>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="field">
                            <label for="name">State <span className="req">*</span></label>
                            <input
                                type="text"
                                readOnly={true}
                                id="state"
                                name="state"
                                placeholder="Enter Your State"
                                autoComplete='off'
                                value={values.state}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.state && touched.state ? (
                                <p className='errormsg'>{errors.state}</p>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="field">
                            <label for="name">Select City <span className="req">*</span></label>
                            <select
                                id='city'
                                value={values.city}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    if (selectedValue === 'selects') {
                                        setFieldValue('city', '');
                                    }
                                    else {
                                        setFieldValue('city', selectedValue);
                                    }

                                }}
                                onBlur={handleBlur}
                            >
                                <option value={'selects'}>Select city</option>
                                {citys.length > 0 ? (<>
                                    {citys.map((item) => {
                                        return (
                                            <option key={item.pincode_id} value={item.pincode_id}>{item.city_name}</option>
                                        );
                                    })}
                                </>) : <option value={'selects'}>Select city</option>}
                            </select>

                            {errors.city && touched.city ? (
                                <p className='errormsg'>{errors.city}</p>
                            ) : null}
                        </div>
                    </Col>

                    <Col md={12}>
                        <div className='buttonbox'>
                            <button type='submit' className='btn btn-green'>{props.editAddress ? 'Update Address' : 'Save Address'}</button>
                            <button type='button' style={{ marginLeft: '15px' }} onClick={() => props.hendelCancel()} className='btn btn-red'>Cancel</button>
                        </div>
                    </Col>
                </Row>
            </form>
            {isLoading ? <Loader /> : null}
        </div>
    )
}

export default AddAddress